import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import PerfectScrollbar from "react-perfect-scrollbar";
import t from "translations";
import Chip from "@material-ui/core/Chip";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import { useStoreon } from "storeon/react";

const Wrap = styled.div(({ show }) => ({
  padding: !show ? 0 : 10,
  width: !show ? 0 : "100%",
}));

// selectedId !== -1 && isMobile

export const Title = styled.h2({
  fontFamily: "Lato",
  fontWeight: 900,
  fontSize: 26,
  margin: "16px 0",
  "@media screen and (max-width: 480px)": {
    marginTop: 0,
  },
});

const Scroll = styled(PerfectScrollbar)({
  height: "calc(100% - 94px)",
  "@media screen and (max-width: 480px)": {
    height: "100%",
  },
});

const ProductsWrap = styled.div({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "start",
  justifyContent: "left",
  maxHeight: "80vh",
  minWidth: "100%",
  width: "calc(70vw - 440px)",
  ">div": {
    flex: "0 0 32%",
    margin: "0.6%",
  },
  "@media screen and (max-width: 480px)": {
    ">div": {
      flex: "0 0 48.8%",
      margin: "0.6%",
    },
    maxHeight: "none",
  },
});

const Product = styled.div(({ selected }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "center",
  width: "20vw",
  img: {
    outline: selected ? "4px solid #a8bb43" : "1px solid #ccc",
    ":hover": {
      outline: selected ? "3px solid #a8bb43" : "2px solid #a8bb43",
      filter: "brightness(0.9)",
    },
  },
  ">b": {
    fontSize: 16,
    fontWeight: 900,
  },
  ":hover": {
    cursor: "pointer",
  },
}));

const ImageContainer = styled.div({
  paddingTop: "100%",
  width: "100%",
  position: "relative",
  marginBottom: 10,
  ">img": {
    objectFit: "cover",
    maxWdith: "100%",
    maxHeight: "100%",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
});

const CategoryTagsWrap = styled.div({
  marginBottom: 5,
  marginLeft: 10,
  display: "inline-block",
  fontWeight: "normal",
  "> div": {
    marginRight: 8,
  },
  "@media screen and (max-width: 480px)": {
    marginLeft: 0,
  },
});

const SelectProducts = styled(Title)({
  display: "inline-block",
  "@media screen and (max-width: 480px)": {
    display: "none",
  },
});

const CategoryTags = ({ categoryId, onCategoryCleared, onFiltersToggle }) => {
  const { productCategories } = useStoreon("productCategories");

  const category = productCategories?.find((c) => c.id === categoryId);
  if (!category) {
    return (
      <CategoryTagsWrap>
        <Chip
          icon={<AccountTreeIcon />}
          clickable
          onClick={onFiltersToggle}
          label={t.filters}
          variant="outlined"
        />
      </CategoryTagsWrap>
    );
  }
  return (
    <CategoryTagsWrap>
      <Chip
        icon={<AccountTreeIcon />}
        clickable
        onClick={onFiltersToggle}
        label={t.filters}
        variant="outlined"
      />
      <Chip label={t.reset} onDelete={onCategoryCleared} />
      <Chip
        label={category.label}
        onDelete={onCategoryCleared}
        variant="outlined"
      />
    </CategoryTagsWrap>
  );
};

export const ProductsList = ({
  show,
  parentProducts,
  selectedProduct,
  onProductSelected,
  onCategoryCleared,
  categoryId,
  onFiltersToggle,
}) => {
  return (
    <Wrap show={show}>
      <SelectProducts>{t.selectProduct}</SelectProducts>
      <CategoryTags
        onCategoryCleared={onCategoryCleared}
        onFiltersToggle={onFiltersToggle}
        categoryId={categoryId}
      />
      <Scroll>
        <ProductsWrap>
          {parentProducts?.map((p) => {
            return (
              <Product
                selected={p.id === selectedProduct?.id}
                key={p.id}
                onClick={() => {
                  onProductSelected?.(p);
                }}
              >
                <ImageContainer>
                  <img src={p.image} alt="product" />
                </ImageContainer>
                <b>{p.title}</b>
              </Product>
            );
          })}
        </ProductsWrap>
      </Scroll>
    </Wrap>
  );
};
